export default "__VITE_ASSET__Dr41A3MO__"